import { useQueryClient } from 'react-query';

import { useAuthContext } from '@catalyze/ui';
import { useUpdateUserMutation } from 'api/users/updateUser';

import {
    ProfileToggleContainer,
    ToggleContainer,
    ToggleTextContainer,
} from './styled';

export const ProfileToggle = () => {
    const queryClient = useQueryClient();

    const { user } = useAuthContext();
    const { mutate } = useUpdateUserMutation({
        onSuccess: async () => {
            await queryClient.invalidateQueries(['user']);
        },
    });

    if (!user) {
        return <div />;
    }
    return (
        <ProfileToggleContainer>
            <ToggleContainer>
                <span>DNC Toggle</span>
                <label className="switch">
                    <input
                        type="checkbox"
                        onChange={(cb) =>
                            mutate({ data: { showDnc: cb.target.checked } })
                        }
                        checked={user.showDnc}
                    />
                    <span className="slider round" />
                </label>
            </ToggleContainer>
            {user.showDnc && (
                <ToggleTextContainer>
                    Phone numbers with an orange indicator next to them means
                    they are on the national do not call registry.
                </ToggleTextContainer>
            )}
        </ProfileToggleContainer>
    );
};
